export default __webpack_public_path__ + "static/media/attentionSchool.97a6e2e0.svg";